export default __webpack_public_path__ + "static/media/ads1.c6aba97a.jpg";